/**
 * Debounce method
 *
 * @param {Function} callback - the callback method
 * @param {number} waitTime - the debounce wait time
 * @returns {Function} the debounced handler
 */
export default function debounce (callback, waitTime = 0) {
  let timeout

  /**
   * The debounced handler
   *
   * @param {...any} args
   */
  function debounced (...args) {
    const context = this

    const later = function () {
      timeout = null
      callback.apply(context, args)
    }

    clearTimeout(timeout)
    timeout = setTimeout(later, waitTime)
  }

  debounced.cancel = function () {
    clearTimeout(timeout)
  }

  return debounced
}
